._1lbslxs0 {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 12px;
  border-radius: var(--_6225erv);
  border: 1px solid var(--_6225era);
  box-shadow: var(--_6225erp);
  background-color: var(--_6225er6);
  max-width: 360px;
  position: relative;
}
._1lbslxs1 {
  display: flex;
  align-items: flex-start;
  pointer-events: auto;
  z-index: 1000;
}
._1lbslxs2 {
  visibility: hidden;
}
._1lbslxs3 {
  align-items: flex-end;
}
._1lbslxs4 {
  flex-direction: row-reverse;
}
._1lbslxs5 {
  flex-direction: row;
}
._1lbslxs6 {
  color: var(--_6225er4);
  font-size: var(--_6225er1x);
  font-weight: var(--_6225er1y);
  white-space: nowrap;
  margin-right: 28px;
}
._1lbslxs7 {
  color: var(--_6225er4);
  font-size: var(--_6225er1l);
  font-weight: var(--_6225er1m);
  margin-bottom: 6px;
}
._1lbslxs8 {
  pointer-events: none;
  width: 58px;
  margin-top: 6px;
  color: var(--_6225er1);
}
._1lbslxs9 {
  transform: rotate(180deg);
  margin-right: 2px;
}
._1lbslxsa {
  transform: scaleY(-1);
  margin-left: 2px;
}
._1lbslxsb {
  margin-top: 0;
  margin-bottom: 6px;
}
._1lbslxsc {
  transform: scaleX(-1);
  margin-right: 2px;
}
._1lbslxsd {
  margin-left: 2px;
}